import { Column as PRColumn } from "primereact/column";
import { ColumnProps } from "./column.interface";

export const Column = <T,>(props: ColumnProps<T>) => {
	return <PRColumn {...props} />;
};
